<template>
  <div class="custom-date-picker-div">
    <a-date-picker
        v-if="!isToNow"
        :value="innerValue"
        valueFormat="YYYY-MM-DD"
        @change="handleChange"
        placeholder="请选择日期"
        :disabled="disabled"
        style="width: 100%"
    >
      <template slot="renderExtraFooter">
        <a @click="handleToNow('9999-12-31')" class="ant-calendar-today-btn">至今</a>
      </template>
    </a-date-picker>
    <a-input v-else value="至今" disabled style="width: 100%">
      <template #addonAfter>
        <a-icon type="edit" style="color: #1890FF" @click="cancelToNow" />
      </template>
    </a-input>
<!--    <a-input v-else value="至今" disabled style="width: 100%" />-->
<!--    <a-icon type="edit" v-if="!disabled && isToNow" @click="cancelToNow" style="margin-left: 4px;color: #1890FF" />-->
  </div>
</template>

<script>
export default {
  name: 'DatePickerWithToNow',
  props: {
    value: [String, Object],
    disabled: Boolean
  },
  data() {
    return {
      isToNow: this.value === '9999-12-31',
      innerValue: this.value
    }
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal
      this.isToNow = newVal === '9999-12-31'
    }
  },
  methods: {
    handleChange(value) {
      this.innerValue = value
      this.isToNow = false
      this.$emit('change', value)
    },

    handleToNow(value) {
      this.isToNow = true
      this.innerValue = value
      this.$emit('change', value)
    },

    cancelToNow() {
      this.isToNow = false
      this.innerValue = null
      this.$emit('change', null)
    }
  }
}
</script>
<style lang="css">
  .custom-date-picker-div {}
  .ant-calendar-footer-btn {
    display: flex;
  }
  .ant-calendar-footer-extra {
    width: 100%;
    border-right: 1px solid lightgray;
  }
  .ant-calendar-today-btn {
    width: 100%;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/infocollect/components/DatePickerWithtoNow.vue